import { useState, useEffect } from 'react';
import { ProductCalculation } from 'api/LoanOriginationSystem/ProductCalculationsApi';
import { useProductCalculationsApi } from 'providers/ApiServiceProvider';

const useProductCalculations = (productId: string | null) => {
  const [productCalculations, setProductCalculations] = useState<ProductCalculation[] | null>(null);
  const productCalculationsApi = useProductCalculationsApi();

  useEffect(() => {
    if (!productId) {
      return;
    }

    productCalculationsApi.getByProduct(productId).then((calculations) => setProductCalculations(calculations));
  }, [productId]);

  return productCalculations;
};

export default useProductCalculations;
